import { ContactPhone, ExitToApp, LockOpen, Person, WorkOutline } from '@mui/icons-material';
import { Routing } from '@fabiulous/routing/dist/types';

import config from '@shared/config';
import { Dictionary } from '@shared/dictionary';


export const routes = {
  home: '/',
  welcome: '/welcome',
  partnerPortal: '/partner-portal',
  homeownerHub: {
    path: '/4i-energyhub',
    routes: {
      login: '/login',
      dashboard: '/dashboard',
      learn: '/learn',
      learnModule: (moduleId: string = ':moduleId') => `/learn/${moduleId}`,
      explore: '/explore',
      profile: '/profile',
      consultation: '/consultation',
      messages: '/messages',
      about: '/about',
      help: '/help',
    },
  },
  auth: {
    path: '/auth',
    routes: {
      impersonateUser: '/impersonate',
      login: '/login',
      resetPasswordConfirm: '/reset-password-confirm',
      resetPassword: '/reset-password',
      signup: '/signup',
    },
  },
  team: '/team',
  users: {
    path: '/users',
    routes: {
      create: '/create',
      myAccount: '/my-account',
      edit: (userId: string | number = ':userId') => `/edit/${userId}`,
      invite: (token: string = ':token') => `/invitation/${token}`,
    },
  },
  companies: {
    path: '/companies',
    routes: {
      create: '/create',
      edit: (companyId: string | number = ':companyId') => `/edit/${companyId}`,
    },
  },
  leads: {
    path: '/leads',
    routes: {
      impersonate: (leadId: string | number = ':leadId') => `/${leadId}/impersonate`,
    },
  },
  leadForm: {
    path: '/lead-form',
    routes: {
      byPartner: (partnerSlug: string = ':partnerSlug') => `/${partnerSlug}`,
    },
  },
  projects: {
    path: '/projects',
    routes: {
      board: '/board',
      view: (projectId: number | string = ':projectId') => ({
        path: `/view/${projectId}`,
        routes: {
          work: '/work',
          property: '/property',
          finances: '/finances',
          docs: '/docs',
          invoices: '/invoices',
          changelog: '/changelog',
          solarDesign: '/solar-design',
        },
      }),
    },
  },
};

export const navigation = (router: Routing.RecursiveRoutes<typeof routes>, dictionary: Dictionary): CVT.Navigation.Config => ({
  userMenu: [{
    icon: <Person/>,
    text: dictionary.menu.users.myAccount,
    route: router.users.myAccount.path,
    requiresAuth: true,
  }, {
    icon: <LockOpen/>,
    text: dictionary.menu.auth.login,
    route: router.auth.login.path,
    requiresAuth: false,
  }, ...(config.featureFlags.signup ? [{
    icon: <ExitToApp/>,
    text: dictionary.menu.auth.signUp,
    route: router.auth.signup.path,
    requiresAuth: false,
  }] : [])],
  sidebar: [{
    icon: <WorkOutline/>,
    text: dictionary.menu.projects.list,
    route: router.home.path,
    requiresAuth: true,
    permission: 'projects.view',
  }, {
    icon: <ContactPhone/>,
    text: dictionary.menu.leads.list,
    route: router.leads.path,
    requiresAuth: true,
    permission: 'leads.view',
  }],
});
